// Canonical FEEDER legal copy. Replace only from the approved Stay Planner
// imprint source; do not infer or complete legal facts in this module.
export const feederLegalContent = Object.freeze({
  publicationStatus: "approved",
  title: "Impressum",
  introduction: "Betreiber von FEEDER und feeder.at",
  sections: Object.freeze([
    Object.freeze({
      id: "operator",
      heading: "Betreiber",
      lines: Object.freeze([
        "Philipp Viktor Koneczny, BSc",
        "Einzelunternehmer",
        "Blumenweg 4, Tür 1",
        "5400 Hallein",
        "Österreich",
      ]),
    }),
    Object.freeze({
      id: "contact",
      heading: "Kontakt",
      lines: Object.freeze([
        "E-Mail: philovescoding@gmail.com",
      ]),
    }),
    Object.freeze({
      id: "trade",
      heading: "Gewerbe",
      lines: Object.freeze([
        "Gewerbewortlaut: Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik",
        "GISA-Zahl: 40059389",
        "Gewerbebehörde: Bezirkshauptmannschaft Hallein",
      ]),
    }),
  ]),
  uid: "",
})
